import React from "react";
import iguanodonFull from "../img/iguanodon-full.webp";

const Iguanodon = () => {
  return (
    <div className="mt-5 p-10 flex justify-center items-center">
      <img src={iguanodonFull} alt="Iguanodon" />
    </div>
  )
}

export default Iguanodon;